export default {
      id: "info-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }